export default {
  code: '404',
  title: 'Nie znaleziono strony',
  description: 'Strona, ktorej szukasz, nie istnieje lub nie jest juz dostepna.',
};
